var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58155 0.66924C7.92863 -0.136723 9.07137 -0.136722 9.41845 0.669241L10.8338 3.95573C10.9785 4.29191 11.2954 4.52213 11.6599 4.55593L15.2229 4.88639C16.0966 4.96743 16.4498 6.05424 15.7905 6.63339L13.1022 8.99501C12.8272 9.23658 12.7062 9.60909 12.7867 9.96616L13.5734 13.4569C13.7663 14.3129 12.8419 14.9846 12.0873 14.5366L9.01056 12.7097C8.69584 12.5228 8.30416 12.5228 7.98944 12.7097L4.91268 14.5366C4.15815 14.9846 3.23365 14.3129 3.42659 13.4569L4.21333 9.96616C4.29381 9.60909 4.17277 9.23658 3.89779 8.99501L1.2095 6.63339C0.550241 6.05424 0.903368 4.96743 1.77714 4.88639L5.34013 4.55593C5.70459 4.52213 6.02146 4.29191 6.16624 3.95573L7.58155 0.66924Z",
    fill: "#C03894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/Star1.2dcf7edcd449e4b2aa1e82a27f99b8c4.svg";
export { ForwardRef as ReactComponent };